import {
  Typography,
  ListItem,
  ListItemButton,
  ListItemText,
  TypographyProps,
  ListItemIcon,
  CircularProgress,
} from '@mui/material'
import { nothing } from '$helper/functions/utils'

interface Props {
  // TODO make required
  onClick?: () => unknown
  text: string
  typographyProps?: TypographyProps
  loading?: boolean
}

export function ListItemCriticalTextButton({
  text,
  onClick = nothing,
  typographyProps = {
    variant: 'body2',
    color: 'error',
  },
  loading,
}: Props) {
  const { variant, color } = typographyProps
  return (
    <ListItem disablePadding sx={{ bgcolor: 'white' }}>
      <ListItemButton disabled={loading} onClick={onClick}>
        <ListItemText
          primary={
            <Typography variant={variant} color={color}>
              {text}
            </Typography>
          }
        />
        {loading && (
          <ListItemIcon>
            <CircularProgress size={22} color="error" />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  )
}
